import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const validKid: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const value = control.value;

  if (
    value.toUpperCase().trim().startsWith('KID') &&
    !value
      .trim()
      .charAt(3)
      .match(/^[a-zA-Z]+$/)
  ) {
    return { invalidKid: true };
  }

  return null;
};
